'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _consoleBranding = require('./remote/consoleBranding');

var ConsoleBranding = {
    fetchConsoleBranding: _consoleBranding.ConsoleBrandingRemote.fetchConsoleBranding
};

exports.default = ConsoleBranding;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/consoleBranding.js
// module id = rca8
// module chunks = 60